import {useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  CreateUserDTO,
  UserApiService
} from 'features/users/api/user-api.service';
const { createStationMapping  } = UserApiService();
export const useCreateStationMapping = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: CreateUserDTO) => {
      return createStationMapping(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data:any) => {
        message.success(data?.customMessage)
      },
    },
  );
};










